import Vue from "vue";
import Router from "vue-router";
import { store } from "@/store";

import AccountsOverview from "@/views/AccountsOverview";
import ProfilesOverview from "@/views/ProfilesOverview";
import WebPropertiesOverview from "@/views/WebPropertiesOverview";
import ProfileView from "@/views/ProfileView";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "Accounts Overview",
      component: AccountsOverview,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/accounts/:accountId",
      name: "Webproperties Overview",
      component: WebPropertiesOverview,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/accounts/:accountId/properties/:propertyId",
      name: "Profiles Overview",
      component: ProfilesOverview,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/accounts/:accountId/properties/:propertyId/profiles/:profileId",
      name: "Profile",
      component: ProfileView,
      props: true,
      meta: {
        requiresAuth: true
      }
    }
  ]
});

router.beforeEach((to, from, next) => {
  // redirect to home if not logged in
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next();
      return;
    }
    next("/");
  } else {
    next();
  }
});

export default router;
